import React from 'react'
import Spinner from './Spinner'

function PrimaryButton(props: {
    theme?: 'border' | 'filled' | 'bordered'
    size?: string
    onClick?: (arg?: any) => any
    className?: string
    children?: JSX.Element
    isLoading?: boolean
    isDisabled?: boolean
    rounded?: string
}) {
    const { onClick, children, className = '', isDisabled, isLoading, size = 'lg', rounded = 'rounded-lg', theme = 'filled' } = props

    function getButtonStyle() {
        if (theme === 'border') return {}
        if (theme === 'bordered') return { border: '1px solid #0C3F6D' }
        if (isDisabled || isLoading) return { background: 'linear-gradient(90.76deg, #0C3A57 0.13%, #14285D 52.45%)' }
        // if (isLoading) return { background: 'linear-gradient(90.76deg, #0C3A57 0.13%, #14285D 52.45%)' }
        return { background: '#366FB7' }
    }

    function getTextColor() {
        //text-[#0D0C1E]
        if (theme === 'border') return 'white'
        if (theme === 'bordered') return 'white'
        if (isDisabled || isLoading) return 'white'
        // if (isLoading) return { background: 'linear-gradient(90.76deg, #0C3A57 0.13%, #14285D 52.45%)' }
        return 'text-white'
        // return 'text-[#0D0C1E]'
    }

    function renderLoading() {
        if (!isLoading) return null

        return <Spinner className='mr-2 opacity-20' />
    }

    return (
        <div
            className={`${className}  ${rounded ? rounded : 'rounded-lg'} flex ${size === 'sm' ? 'px-2 py-2 h-[34px]' : 'h-[46px] lg:p-3 p-2'} items-center justify-center ${
                isDisabled ? 'cursor-not-allowed text-[#3A4164]' : 'cursor-pointer text-black'
                // isDisabled ? 'cursor-not-allowed text-[#3A4164]' : 'cursor-pointer text-white'
            }`}
            style={getButtonStyle()}
            onClick={isDisabled ? () => {} : onClick}>
            <span className={`flex items-center text-[14px] normal-case lg:text-[16px] ${isLoading ? 'text-[#3A4164]' : `${getTextColor()}`}`}>
                {/* <span className={`flex items-center text-[18px] normal-case lg:text-[20px] ${isLoading ? 'text-[#3A4164]' : ''}`}> */}
                {renderLoading()}
                {children}
            </span>
        </div>
    )
}

export default PrimaryButton
